import styled from '@emotion/styled';
const Progress = styled.progress `
  appearance: none;
  border: none;
  min-width: 100%;
  height: 0.8rem;

  &::-webkit-progress-bar {
    background-color: ${({ theme }) => theme.color.background.tertiary};
    border-radius: ${({ theme }) => theme.borderRadius[100]};
    overflow: hidden;
  }

  &::-webkit-progress-value {
    background-color: ${({ theme }) => theme.color.background.interactiveActionBase};
    border-radius: ${({ theme }) => theme.borderRadius[100]};
    transition: width 0.5s;
  }
`;
export { Progress };
//# sourceMappingURL=styled.js.map